<span class="badge rounded-pill bg-{{class}}">
    <ng-content></ng-content>
</span>